// SpecRef: ARCH-005
// Reference: docs/decisions/ARCH-005-ui-error-detection-resilience.md#9-schema-level-empty-data-detection
// v.check on data array raises @WARNING when backend returns zero new cases.
import * as v from 'valibot';

import { newCaseSchema } from '#entities/schemas';

export const newCasesResponseSchema = v.object({
  /** Array of new cases */
  data: v.pipe(
    v.array(newCaseSchema),
    v.check(
      arr => arr.length > 0,
      '@WARNING: No new cases returned — backend may be unavailable or data is stale',
    ),
  ),
  /** Timestamp when the report was generated (ISO 8601) */
  dataGeneratedAt: v.string(),
  errors: v.nullable(v.array(v.unknown())),
  expires: v.nullable(v.string()),
  errorsGeneratedAt: v.nullable(v.string()),
  /** Opaque change-stream cursor (ISO 8601 timestamp); seeds the case cursor store. */
  cursor: v.optional(v.string()),
});

export type NewCasesResponse = v.InferInput<typeof newCasesResponseSchema>;
